import { render, staticRenderFns } from "./Farms.vue?vue&type=template&id=78830476&scoped=true"
import script from "./Farms.vue?vue&type=script&lang=js"
export * from "./Farms.vue?vue&type=script&lang=js"
import style0 from "./Farms.vue?vue&type=style&index=0&id=78830476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78830476",
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QInput,QIcon,QBtn,QTh,QTd,QBadge,QTooltip,QCard,QSeparator,QDialog,QCheckbox,QToggle,QLinearProgress});qInstall(component, 'directives', {ClosePopup});
